import request from '@/utils/request'
import type {
  LoginNopassParams,
  LoginParams,
  LoginResult,
  ModifyUserInfoParams,
  UserInfo,
} from '@/types/user'

export interface McpAuthorizationResult {
  status: 'authorized'
  callbackUrl: string
}

let pendingMcpCallbackUrl = ''

/**
 * 免密联登（通过加密字符串）
 */
export const loginNopass = (data: LoginNopassParams, dongchaEntry = false) => {
  return request.post<LoginResult>(
    '/commonfacade/user/login/nopass',
    data,
    dongchaEntry
      ? { silent: true, headers: { 'X-QX-Dongcha-Entry': '1' } }
      : undefined,
  )
}

/**
 * 发送短信验证码
 */
export const sendSms = (data: { mobile: string }) => {
  return request.post('/commonfacade/user/sms/send', data, { skipUrlSourceType: true })
}

/**
 * 短信登录
 */
export const loginSms = (data: LoginParams) => {
  return request.post<LoginResult>('/commonfacade/user/login/sms', data, { skipUrlSourceType: true })
}

export const bindCurrentAiAccess = (data: { source: string; apiKey: string }) => {
  return request.post<boolean>('/commonfacade/user/ai-access/bind', data, { skipUrlSourceType: true })
}

/**
 * 使用当前轻息登录态完成一次 MCP 浏览器授权。
 * QX token 由统一 request 拦截器读取，调用方不得手动传入。
 */
export const completeMcpAuthorization = async (
  authRequest: string,
  suppressStaleLogin = false,
) => {
  const form = new URLSearchParams({
    auth_request: authRequest,
  })
  const result = await request.post<McpAuthorizationResult>('/mcpfacade/oauth/complete', form.toString(), {
    encrypt: false,
    silent: suppressStaleLogin,
    suppressTokenLoss: suppressStaleLogin,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
  })
  if (result.status !== 'authorized' || !result.callbackUrl) {
    throw new Error('MCP authorization result is invalid')
  }
  pendingMcpCallbackUrl = result.callbackUrl
  return result
}

/**
 * 结果页只能一次性消费刚由后端返回的安全回调地址。
 * 刷新、后退或直接打开结果页均不会获得可跳转的外部地址。
 */
export const consumeMcpCallbackUrl = () => {
  const callbackUrl = pendingMcpCallbackUrl
  pendingMcpCallbackUrl = ''
  return callbackUrl
}

/**
 * 修改用户信息
 */
export const modifyUserInfo = (data: ModifyUserInfoParams) => {
  return request.post('/commonfacade/user/info/modify', data)
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return request.get<UserInfo>('/commonfacade/user/getUserInfo')
}

/**
 * 退出登录
 */
export const logout = () => {
  return request.post('/commonfacade/user/loginout')
}

/**
 * 销毁账号
 */
export const destroyAccount = () => {
  return request.post('/commonfacade/user/account/destroy')
}
